import React from 'react';

import ReactDOM from 'react-dom/client';
import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType
} from 'react-router-dom';

import './index.css';

import * as Sentry from '@sentry/react';

import App from './App';
import { env } from './env';

Sentry.init({
  dsn: 'https://080810d6dbdeaf2236ed95cacd2e1736@o366774.ingest.us.sentry.io/4509628376875008',
  tunnel: 'tu-tu-nail',

  environment: env.VITE_ENV,
  integrations: [
    new Sentry.BrowserTracing({
      routingInstrumentation: Sentry.reactRouterV6Instrumentation(
        React.useEffect,
        useLocation,
        useNavigationType,
        createRoutesFromChildren,
        matchRoutes
      )
    }),
    new Sentry.Replay()
  ],

  // Set `tracePropagationTargets` to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: ['stratumn.com'],

  sampleRate: 1.0,
  enableTracing: true,

  enabled: env.VITE_ENV !== 'local',

  replaysSessionSampleRate: 0.01,
  replaysOnErrorSampleRate: 1.0,
  tracesSampleRate: 1.0,
  profilesSampleRate: 0.1
});

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
